import { useState } from 'react';
import styles from './DescriptionField.module.css';

export function DescriptionField({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const [focused, setFocused] = useState(false);

  return (
    <input
      type="text"
      className={styles.input}
      style={{ '--description-border-color': focused ? 'var(--info)' : 'var(--g200)' } as React.CSSProperties}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      maxLength={1000}
      autoFocus
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
}
